import { FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export const DisabledRequiredControlsValidator = (disabledControls: string[]): ValidatorFn => {
  return (formGroup: FormGroup): ValidationErrors | null => {
    let hasInvalidControl = false;

    disabledControls.forEach(controlName => {
      const control = formGroup.get(controlName);
      if (control && !control.value) {
        hasInvalidControl = true;
      }
    });
    return hasInvalidControl ? { customMessage: 'Disabled value required' } : null;
  };
};
